import { render, staticRenderFns } from "./Erp6SaleBaseProductPrice.vue?vue&type=template&id=7aebcef0&scoped=true&"
import script from "./Erp6SaleBaseProductPrice.vue?vue&type=script&lang=js&"
export * from "./Erp6SaleBaseProductPrice.vue?vue&type=script&lang=js&"
import style0 from "./Erp6SaleBaseProductPrice.vue?vue&type=style&index=0&id=7aebcef0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aebcef0",
  null
  
)

export default component.exports